module.exports = __webpack_public_path__ + "img/28545604000132.eccbc592.png";